"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var filters_1 = require("@/filter/filters");
var ScheduleViewer_vue_1 = __importDefault(require("@/components/schedule-viewer/ScheduleViewer.vue"));
var RatingStarsReader_vue_1 = __importDefault(require("@/components/rating-stars-reader/RatingStarsReader.vue"));
var ImagesGalleryExtended_vue_1 = __importDefault(require("@/components/images-gallery/extended/ImagesGalleryExtended.vue"));
var CategoriesList_vue_1 = __importDefault(require("@/components/categories-list/CategoriesList.vue"));
var PointOfInterestMapSide = /** @class */ (function (_super) {
    __extends(PointOfInterestMapSide, _super);
    function PointOfInterestMapSide() {
        var _this = _super.call(this) || this;
        _this.loader = false;
        _this.pointOfInterest = null;
        return _this;
    }
    PointOfInterestMapSide.prototype.onChangeId = function () {
        this.httpRequest();
    };
    PointOfInterestMapSide.prototype.mounted = function () {
        this.httpRequest();
    };
    PointOfInterestMapSide.prototype.httpRequest = function () {
        var _this = this;
        this.loader = true;
        this.$getListPointOfInterest.request([this.pointOfInterestId]).then(function (response) {
            if (response[0]) {
                _this.loader = false;
                _this.pointOfInterest = response[0];
            }
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    PointOfInterestMapSide.prototype.viewImageGallery = function () {
        if (this.pointOfInterest === null) {
            return;
        }
        if (this.pointOfInterest.images.length) {
            this.$bvModal.show('images-gallery-modal-' + this.pointOfInterest.id);
        }
    };
    PointOfInterestMapSide.prototype.goToExtendedView = function () {
        var _a;
        this.$router.push({ name: 'pointOfInterestDataById', params: { pointOfInterestId: (_a = this.pointOfInterest) === null || _a === void 0 ? void 0 : _a.id } });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], PointOfInterestMapSide.prototype, "pointOfInterestId", void 0);
    __decorate([
        vue_property_decorator_1.Watch('pointOfInterestId')
    ], PointOfInterestMapSide.prototype, "onChangeId", null);
    PointOfInterestMapSide = __decorate([
        vue_property_decorator_1.Component({
            name: 'PointOfInterestMapSide',
            filters: {
                translation: filters_1.translation,
                getFirstImageUrl: filters_1.getFirstImageUrl,
                dateFormat: filters_1.dateFormat
            },
            components: {
                ScheduleViewer: ScheduleViewer_vue_1.default,
                RatingStarsReader: RatingStarsReader_vue_1.default,
                ImagesGalleryExtended: ImagesGalleryExtended_vue_1.default,
                CategoriesList: CategoriesList_vue_1.default
            }
        })
    ], PointOfInterestMapSide);
    return PointOfInterestMapSide;
}(vue_1.default));
exports.default = PointOfInterestMapSide;
